import Vue from 'vue'
import Router from 'vue-router'

//Pages
import Home from '../pages/Home/Home/Router'
import MinhaConta from '../pages/Inicio/MinhaConta/Router'
import Logs from '../pages/Logs/Logs/Router'

import Patrimonio from '../pages/Sistema/Equipamentos/Router'
import Condicoes from '../pages/Admin/Condicoes/Router'
import Empresas from '../pages/Admin/Empresas/Router'
import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Router'
import Situacoes from '../pages/Admin/Situacoes/Router'
import Status from '../pages/Admin/Status/Router'
import Usuarios from '../pages/Admin/Usuarios/Router'
import Voltagem from '../pages/Admin/Voltagem/Router'
import Ver from '../pages/Ver/Ver/Router'

import Redirect from '../pages/redirect/Index/Router'
import Acessar from '../pages/Login/Acessar/Router'
import Erro from '../pages/Erro/404/Router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [
		...Redirect,
		{
			path: '/',
			component: () => import('@/layouts/Default'),
			children: [
				...Home,
				...MinhaConta,
				...Logs,
				...Patrimonio,
				...Condicoes,
				...Empresas,
				...GrupoDeAcesso,
				...Situacoes,
				...Status,
				...Usuarios,
				...Voltagem
			]
		},
		...Acessar,
		{
			path: '/ver',
			component: () => import('@/layouts/Ver'),
			children: [...Ver]
		},
		...Erro,
	]
})
